import { useMemo } from 'preact/hooks'

import { checkConditions } from '@/components/helpers/metaobjects'

/**
 * Takes a criteria object to pass to checkConditions to validate what promo lines should display.
 */

export function usePromoLines(criteria) {
  return useMemo(() => {
    const data = GM_STATE.metaobjects.promolines
    return data
      .filter((line) => checkConditions(line.conditions, criteria))
      .sort((a, b) => b.conditions.priority - a.conditions.priority)
  }, [criteria])
}
